jQuery(function($) {

	var l_window = parseInt($(window).width());
	var header = $('#masthead'); 
 
   

   /******* SLIDER ROW 1 *********/
   /****************************************/
    $('.gallery_js').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     // adaptiveHeight: true,
     arrows: true,
     fade: true,
     autoplay:true,
     autoplaySpeed: 4000,
     focusOnSelect: false,
     pauseOnFocus:false,
     dots:false
  });


     /******* SLIDER ROW 2 *********/
   /****************************************/
    $('.gallery2_js').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     // adaptiveHeight: true,
     arrows: true,
     fade: true,
     autoplay:true,
     autoplaySpeed: 4000,
     focusOnSelect: false,
     pauseOnFocus:false,
     dots:false
  });



    


  // FORM CONTACT LABEL ///

    $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });



});


